import UserForm from '../../../features/admin/forms/UserForm';

const AdminUsersCreate = () => {
  return (
    <UserForm onEdit="0"/>
  )
};
export default AdminUsersCreate